import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	justify-content: flex-end;
	width: 100%;
	gap: 12px;
	padding-top: 24px;
`;
